import { render } from "./ExchangesView.vue?vue&type=template&id=7946419b"
import script from "./ExchangesView.vue?vue&type=script&lang=js"
export * from "./ExchangesView.vue?vue&type=script&lang=js"

import "./ExchangesView.vue?vue&type=style&index=0&id=7946419b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__